module.exports = __webpack_public_path__ + "static/media/shopcart_empty.7703cea7.jpg";